export class PageResponseModel<T> {
    public data: Array<T> = [];
    public totalCount = 0;
}
